import * as React from "react";
import classNames from "classnames";
import ResponsiveImage from "~/components/responsive-image/responsive-image";
import { ThemeColorType } from "~/types/theme-color";

export interface ImageTextListItemProps {
    title?: string;
    imageSrc?: string;
    imageAltText?: string;
    linkUrl?: string;
    linkTarget?: string;
    textColor?: ThemeColorType;
    bgColor?: ThemeColorType;
    defaultSize?: number;
    srcSetSizes?: number[];
    sizes?: string;
}

const ImageTextListItem = ({
    imageSrc,
    imageAltText,
    linkUrl,
    linkTarget,
    title,
    textColor = ThemeColorType.WHITE,
    bgColor = ThemeColorType.BRAND_3,
    defaultSize,
    srcSetSizes,
    sizes
}: ImageTextListItemProps) => {
    const baseClass = "image-text-list-item";
    const rootClasses = classNames(baseClass, "config-column");
    const linkClasses = classNames(`${baseClass}__link`, {
        [`theme-color-${textColor}`]: textColor,
        [`theme-bg-${bgColor}`]: !imageSrc && !!bgColor
    });

    return (
        <div className={rootClasses}>
            <a className={linkClasses} href={linkUrl} target={linkTarget}>
                {imageSrc && defaultSize && (
                    <div className={`${baseClass}__image-container`}>
                        <ResponsiveImage
                            alt={imageAltText}
                            srcUrl={imageSrc}
                            defaultSize={defaultSize}
                            srcSetSizes={srcSetSizes}
                            sizes={sizes}
                        />
                    </div>
                )}

                {title && (
                    <h3
                        className={`${baseClass}__title h3-style`}
                        dangerouslySetInnerHTML={{ __html: title }}
                    />
                )}
            </a>
        </div>
    );
};

export default ImageTextListItem;
